/* eslint-disable */
export default {
  toolTip: 'Ver em {crmName}',
} as const;

// @key: @#@"toolTip"@#@ @source: @#@"View in {crmName}"@#@
